import {
  create_appointment,
  update_appointment,
  query_appointment_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-area-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'search_text',
      label: '模糊搜索',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写搜索内容',
    },
    // {
    //   type: 'remotemodal',
    //   name: 'shop_id',
    //   label: '预约门店',
    //   disabled: false,
    //   placeholder: '请选择预约门店',
    //   datasourceType: 'remote',
    //   mode: 'default',
    //   allowClear: true,
    //   modalType: 'mjstore-shop',
    // },
    // {
    //   type: 'remotemodal',
    //   name: 'staff_id',
    //   label: '预约治疗师',
    //   disabled: false,
    //   placeholder: '请选择预约治疗师',
    //   datasourceType: 'remote',
    //   mode: 'default',
    //   allowClear: true,
    //   modalType: 'mjstore-staff',
    // },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '预约会员',
      disabled: false,
      placeholder: '请选择预约客户',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    search_text: null,
    customer_id: null,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    // {
    //   type: 'input',
    //   name: 'note',
    //   label: '预约号',
    //   disabled: false,
    //   allowClear: true,
    //   inputType: 'text',
    //   defaultValue: '',
    //   placeholder: '请填写预约号',
    // },
    {
      type: 'datepicker',
      name: 'start_datetime',
      label: '预约开始时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm',
      valueFormat: 'YYYY-MM-DD HH:mm',
      placeholder: '请填写开始时间',
    },
    {
      type: 'datepicker',
      name: 'end_datetime',
      label: '预约结束时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm',
      valueFormat: 'YYYY-MM-DD HH:mm',
      placeholder: '请填写结束时间',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '预约门店',
      disabled: !!current_shop,
      placeholder: '请选择预约门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '预约治疗师/医生',
      disabled: false,
      placeholder: '请选择预约治疗师',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {
    customer_id: [{ required: true, message: '请填预约会员姓名' }],
    project_id: [{ required: true, message: '请填预约客项目' }],
    shop_id: [{ required: true, message: '请填预约门店' }],
    staff_id: [{ required: true, message: '请填预约治疗师' }],
    start_datetime: [{ required: true, message: '请选择预约开始时间' }],
    end_datetime: [{ required: true, message: '请选择预约结束时间' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    customer_id: null,
    project_id: null,
    note: null,
    start_datetime: null,
    end_datetime: null,
    shop_id: current_shop?.id,
    staff_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    // {
    //   type: 'input',
    //   name: 'note',
    //   label: '预约号',
    //   disabled: false,
    //   allowClear: true,
    //   inputType: 'text',
    //   defaultValue: '',
    //   placeholder: '请填写预约号',
    // },
    {
      type: 'datepicker',
      name: 'start_datetime',
      label: '预约开始时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm',
      valueFormat: 'YYYY-MM-DD HH:mm',
      placeholder: '请填写开始时间',
    },
    {
      type: 'datepicker',
      name: 'end_datetime',
      label: '预约结束时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm',
      valueFormat: 'YYYY-MM-DD HH:mm',
      placeholder: '请填写结束时间',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '预约门店',
      disabled: !!current_shop,
      placeholder: '请选择预约门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '预约治疗师/医生',
      disabled: false,
      placeholder: '请选择预约治疗师',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    customer_id: null,
    project_id: null,
    note: null,
    start_datetime: null,
    end_datetime: null,
    shop_id: current_shop?.id,
    staff_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '预约',
  addModalTitle: '新建预约',
  updateTitle: '编辑预约',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    appointment_id: 'id',
  },
  delete: {
    appointment_id: 'id',
  },
  recover: {
    appointment_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    appointment_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '预约号',
    minWidth: 200,
    dataIndex: 'note',
    checked: true,
  },
  {
    title: '预约门店',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '预约治疗师/医生',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'customer__code',
    checked: true,
  },
  {
    title: '预约人',
    width: 150,
    dataIndex: 'customer__name',
    checked: true,
  },
  {
    title: '预约项目',
    width: 250,
    dataIndex: 'project__name',
    checked: true,
  },
  {
    title: '预约时间',
    width: 250,
    dataIndex: 'interval_time_str',
    checked: true,
  },
  // {
  //   title: '是否可用',
  //   width: 150,
  //   dataIndex: 'is_active',
  //   checked: true,
  //   cellComponent: 'boolean',
  //     name1: '可用',
  //     name2: '禁用',
  //   filterMultiple: false,
  //   filters: [
  //     { text: '全部', value: '' },
  //     { text: '可用', value: true },
  //     { text: '作废', value: false },
  //   ],
  // },
  // {
  //   title: '操作',
  //   width: 100,
  //   dataIndex: 'action',
  //   checked: true,
  //   cellComponent: 'action',
  //   fixed: 'right',
  // },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_appointment_list,
    addData: create_appointment,
    updateData: update_appointment,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
